export default __webpack_public_path__ + "static/media/icon-record.8d2cc548.svg";